import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HotelAdminService from "../../services/hotelAdmin.service";

// **Async Thunks**
export const addHotel = createAsyncThunk(
  "hotelAdmin/addHotel",
  async (item, thunkAPI) => {
    try {
      const response = await HotelAdminService.addHotels(item);
      return response.data; // Return actual data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const gethotelList = createAsyncThunk(
  "hotelAdmin/gethotelList",
  async (item, thunkApi) => {
    try {
      const response = await HotelAdminService.gethotelList(item);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const editHotel = createAsyncThunk(
  "hotelAdmin/editHotel",
  async (item, thunkAPI) => {
    try {
      const response = await HotelAdminService.editHotels(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// **Initial State**
const initialState = {
  loading: false,
  error: "",
  hotelAdmin: [],
};

// **Slice**
const hotelAdminSlice = createSlice({
  name: "hotelAdmin",
  initialState,
  extraReducers: (builder) => {
    builder
      // **Handle Get Hotel List**
      .addCase(gethotelList.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(gethotelList.fulfilled, (state, action) => {
        state.loading = false;
        state.hotelAdmin = action.payload;
      })
      .addCase(gethotelList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Add Hotel**
      .addCase(addHotel.pending, (state) => {
        state.loading = true;
      })
      .addCase(addHotel.fulfilled, (state, action) => {
        state.loading = false;
        state.hotelAdmin.push(action.payload);
      })
      .addCase(addHotel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Edit Hotel**
      .addCase(editHotel.pending, (state) => {
        state.loading = true;
      })
      .addCase(editHotel.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.hotelAdmin.findIndex((h) => h.id === action.payload.id);
        if (index !== -1) {
          state.hotelAdmin[index] = action.payload;
        }
      })
      .addCase(editHotel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// **Export Reducer**
export default hotelAdminSlice.reducer;
